module.exports = "./img/desktop_logo.8764993.png";